import styled from "styled-components";

export const DashboardWrapper = styled.div`
  padding: 8px;
  position: relative;
.cards-items {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 12px;
    .items-wrapper {
    box-shadow: 0px 4px 30px 0px #0000001A;
    padding: 12px;
    border-radius: 6px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    header {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    h6 {
    margin: 0px;
    color: #858D9D;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
}
svg {
    font-size: 16px;
    color: #1565D8;
}
}
.items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 28px;
    .content {
    display: flex;
    flex-direction: column;
    p {
      color: #1F1F1F;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0px;
      margin: 0px;
      &:not(:first-child) {
        color: #777980;
}
    }
}
}
}
}
.container-overlay {
    display: flex;
    position: absolute;
    top: 58px;
    z-index: 2;
    left: 38px;
    grid-gap: 105px;
    h5 {
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #1565D8;
    margin: 0px;
}
}
.right-container {
    display: flex;
    grid-gap: 48px;
    .tabs-wrapper {
    display: flex;
    grid-gap: 8px;
    border-bottom: 1px solid #E5E5EA;
    p {
    margin: 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #989898;
    cursor: pointer;
    &.active{
      border-bottom: 2px solid #1565D8;
      color: #1565D8;
    }
}
}
}
`;